import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';
import {TextVariantType} from '~/types';

export const TEXT_VARIANTS = {
  NO_STYLE: 'NO_STYLE',
};

export function Text({
  as,
  children,
  className,
  style,
  variant,
  testid,
}: {
  className?: string;
  style?: object;
  children: React.ReactNode;
  as?: TextVariantType;
  variant?: typeof TEXT_VARIANTS[keyof typeof TEXT_VARIANTS];
  testid?: string;
}) {
  const Component = as ?? 'span';

  return (
    <Component
      data-testid={testid}
      style={style}
      className={twMerge(
        clsx(
          variant === TEXT_VARIANTS.NO_STYLE
            ? undefined
            : {
                'font-extrabold font-header':
                  Component !== 'p' && Component !== 'span',
                'text-3.5xl md:text-4xl': Component === 'h1',
                'text-xl md:text-4xl': Component === 'h2',
                'text-2lg md:text-3xl': Component === 'h3',
                'text-2xl md:text-2xl': Component === 'h4',
                'text-base md:text-lg': Component === 'h5',
                'text-sm md:text-sm': Component === 'h6',
                'text-xs md:text-base font-normal':
                  Component === 'p' || Component === 'span',
              },
        ),
        className,
      )}
    >
      {children}
    </Component>
  );
}
